import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Typography,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import Bus from "../../assets/bus.svg";
import plane from "../../assets/plane.svg";
import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import link from "../../assets/link.svg";
import airPlane from "../../assets/airplane.png";
import carImage from "../../assets/carImage.jpg";
import {
  Add,
  CloudUploadOutlined,
  FileDownload,
  ContentCopy,
} from "@mui/icons-material";
import DashboardLayout from "layout";
import ReUseAbleTabs from "shared/ReUseAbleTabs";
import DashboardTopTitle from "components/DashboardTopTitle";
import OrderTable from "shared/OrderTable";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getFlightDashboard } from "services/booking";
import { IFlightDataResponse } from "pages/SearchPNR/types/flight";
import { calculateFlightDuration, getStatusStyle } from "utils/misc";
import { LoadingState } from "components/LoadingState";

const BookingOrderDetails = () => {
  const [value, setValue] = React.useState(0);
  const [showNextPage, setShowNextPage] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copiedText, setCopiedText] = useState("");

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { id } = useParams();
  // React Query (not a mount effect) so revisits reuse the cached booking.
  const flightQuery = useQuery<IFlightDataResponse>({
    queryKey: ["flightDashboard", id],
    queryFn: () => getFlightDashboard(id as string),
    enabled: Boolean(id),
  });
  const flightData = flightQuery.data ?? null;
  // Without an id there is nothing to show, so keep the loader (as before).
  const loading = !id || flightQuery.isLoading;
  const error = flightQuery.error;

  const handleCopy = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(label);
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const checkStatus = localStorage.getItem("dashboardView");

  const tabs = [
    {
      label: "Flight and User Details",
      path: "/bookings/orderdetails/flightdetails",
      Component: (
        <FlightDetails
          airline={flightData?.data?.FlightModels.AirlineName || ""}
          flightNumber={flightData?.data?.PnrReferenceNumber || ""}
          classType={
            flightData?.data?.FlightModels.FlightLegs?.[0]?.CabinClassName || ""
          }
          email={flightData?.data?.contactInfo.email || ""}
          phone={flightData?.data?.contactInfo.phoneNumber || ""}
          lastReminderSentAt={flightData?.data?.lastReminderSentAt || ""}
          baggage={
            flightData?.data?.FlightModels.FreeBaggage.BagCount +
              "" +
              flightData?.data?.FlightModels.FreeBaggage.WeightUnit || ""
          }
          amount={flightData?.data?.price.toLocaleString("en-us") || ""}
          onCopy={handleCopy}
        />
      ),
    },
    // {
    //   label: "Passengers",
    //   path: "/bookings/orderdetails/passengers",
    //   Component: <Passengers />,
    // },
  ];

  return (
    <React.Fragment>
      {(loading || error) && <LoadingState />}

      {!loading && !error && (
        <DashboardLayout
          subMenu
          goTo={checkStatus === "1" ? "/bookings/flight" : "/bookings/ride"}
          nextSideBar
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <DashboardTopTitle
              title={`Order Details (${flightData?.data?.booking_id})`}
            />

            {/* <Button
          variant="outlined"
          startIcon={<FileDownload />}
          sx={{
            borderColor: "#E5E7EB",
            backgroundColor: "#FFF",
            color: "#374151",
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "8px",
            px: 2,
            py: 0,
            "&:hover": {
              borderColor: "#D1D5DB",
              backgroundColor: "#F9FAFB",
            },
          }}
        >
          Export Details
        </Button>  */}
          </Box>

          <Box border="1px solid #E4E7EC" width="100%" borderRadius="12px">
            <Box
              height="80px"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              bgcolor="#F0F2F5"
              sx={{
                borderTopRightRadius: "12px",
                borderTopLeftRadius: "12px",
                p: "16px",
              }}
            >
              <Box display="flex" alignItems="center" gap="12px">
                <div
                  style={{
                    height: "48px",
                    width: "48px",
                    borderRadius: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#B5E3C4",
                  }}
                >
                  <img src={plane} alt="" color="#379E66" />
                </div>
                <div>
                  <Typography fontSize={14} fontWeight={600}>
                    {flightData?.data?.FlightModels.DepartureName} to{" "}
                    {flightData?.data?.FlightModels.ArrivalName}
                  </Typography>
                  <Box display="flex" alignItems="center" gap="8px">
                    <Typography fontSize={14}>
                      {flightData?.data.booking_id}
                    </Typography>
                    {flightData?.data.booking_id && (
                      <IconButton
                        size="small"
                        onClick={() =>
                          handleCopy(flightData.data.booking_id, "Booking ID")
                        }
                        sx={{
                          padding: "2px",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        <ContentCopy sx={{ fontSize: 14, color: "#379E66" }} />
                      </IconButton>
                    )}
                  </Box>
                </div>
              </Box>
              <Chip
                label={flightData?.data?.status}
                size="small"
                sx={getStatusStyle(`${flightData?.data?.status || "pending"}`)}
              />
            </Box>

            <Box
              p="16px"
              borderBottom="1px solid #E4E7EC"
              height="112px"
              bgcolor="#FFF"
            >
              <Grid container spacing={2}>
                <Grid item xs={12} lg={4}>
                  <Typography
                    sx={{ color: "#475367", fontWeight: 400 }}
                    fontSize={14}
                  >
                    From
                  </Typography>
                  <Typography fontSize={14}>
                    {
                      flightData?.data?.FlightModels?.FlightLegs[0]
                        .DepartureName
                    }
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Typography
                    sx={{ color: "#475367", fontWeight: 400 }}
                    fontSize={14}
                  >
                    To
                  </Typography>
                  <Typography fontSize={14}>
                    {
                      flightData?.data?.FlightModels?.FlightLegs[0]
                        .DestinationName
                    }
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Typography
                    sx={{ color: "#475367", fontWeight: 400 }}
                    fontSize={14}
                  >
                    Time of departure
                  </Typography>
                  <Typography fontSize={14}>
                    {flightData?.data?.FlightModels?.DepartureTime.split(
                      "T"
                    )[1].substring(0, 5)}
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Typography
                    sx={{ color: "#475367", fontWeight: 400 }}
                    fontSize={14}
                  >
                    Time of Arrival
                  </Typography>
                  <Typography fontSize={14}>
                    {flightData?.data?.FlightModels?.ArrivalTime.split(
                      "T"
                    )[1].substring(0, 5)}
                    (
                    {
                      calculateFlightDuration(
                        flightData?.data?.FlightModels?.DepartureTime || "",
                        flightData?.data?.FlightModels?.ArrivalTime || ""
                      ).formatted
                    }
                    )
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            {/* <Box
          sx={{
            borderBottomRightRadius: "12px",
            borderBottomLeftRadius: "12px",
          }}
          bgcolor="#FFF"
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="49px"
        >
          <Button
            variant="text"
            sx={{
              color: "#379E66",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            Track this event
          </Button>
        </Box> */}
          </Box>

          <Box sx={{ width: "100%" }} mt="24px">
            <Box sx={{ width: "auto" }}>
              <Box sx={{ borderBottom: "1px solid #E4E7EC" }}>
                <ReUseAbleTabs tabs={tabs} />
              </Box>
            </Box>
          </Box>

          {/* Snackbar for copy confirmation */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              {copiedText} copied to clipboard!
            </Alert>
          </Snackbar>
        </DashboardLayout>
      )}
    </React.Fragment>
  );
};

export default BookingOrderDetails;

interface IFlightDetails {
  airline: string;
  flightNumber: string;
  classType: string;
  email: string;
  phone: string;
  lastReminderSentAt: string;
  amount: string;
  baggage: string;
  onCopy: (text: string, label: string) => void;
}

const FlightDetails = ({
  airline,
  flightNumber,
  classType,
  email,
  phone,
  lastReminderSentAt,
  amount,
  baggage,
  onCopy,
}: IFlightDetails) => {
  const checkStatus = localStorage.getItem("dashboardView");

  return (
    <Box>
      <Box display="grid" gridTemplateColumns="55% 45%" gap={2}>
        <Box>
          <div>
            <Typography color="#475367" fontSize={14}>
              Airline Name
            </Typography>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Typography fontSize={16}>{airline}</Typography>
            </div>
          </div>
          <Divider sx={{ my: "12px" }} />
          <Box display="grid" gridTemplateColumns="1fr 1fr">
            <Box sx={{ width: "50%" }}>
              <Typography color="#475367" fontSize={14}>
                PNR Reference Number
              </Typography>
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Typography fontSize={16}>{flightNumber}</Typography>

                {flightNumber && (
                  <IconButton
                    size="small"
                    onClick={() => onCopy(flightNumber, "PNR Reference Number")}
                    sx={{
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <ContentCopy sx={{ fontSize: 16, color: "#379E66" }} />
                  </IconButton>
                )}
              </div>
            </Box>
            <div
              style={{ borderLeft: "1px solid #E4E7EC", paddingLeft: "12px" }}
            >
              <Typography color="#475367" fontSize={14}>
                Class
              </Typography>

              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Typography fontSize={16}>{classType}</Typography>
              </div>
            </div>
          </Box>

          <Divider sx={{ my: "12px" }} />
          <Box display="grid" gridTemplateColumns="1fr 1fr">
            <div>
              <Typography color="#475367" fontSize={14}>
                Email Address
              </Typography>

              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Typography fontSize="16px">{email}</Typography>
                {email && (
                  <IconButton
                    size="small"
                    onClick={() => onCopy(email, "Email")}
                    sx={{
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <ContentCopy sx={{ fontSize: 16, color: "#379E66" }} />
                  </IconButton>
                )}
              </div>
            </div>
            <div
              style={{ borderLeft: "1px solid #E4E7EC", paddingLeft: "12px" }}
            >
              <Typography color="#475367" fontSize={14}>
                Phone Number
              </Typography>

              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Typography fontSize="16px">{phone}</Typography>
                {phone && (
                  <IconButton
                    size="small"
                    onClick={() => onCopy(phone, "Phone Number")}
                    sx={{
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <ContentCopy sx={{ fontSize: 16, color: "#379E66" }} />
                  </IconButton>
                )}
              </div>
            </div>
          </Box>
          <Divider sx={{ my: "12px" }} />
          <Box sx={{ my: "12px" }} />
          <Typography color="#475367" fontSize={14}>
            Baggage Information
          </Typography>
          <Typography fontSize={16}>{baggage}</Typography>
        </Box>
        <Box>
          <Box p="8px" bgcolor="#F0F2F5" borderRadius="12px">
            <img
              src={checkStatus === "1" ? airPlane : carImage}
              alt=""
              width="100%"
              style={{ objectFit: "cover", borderRadius: "12px" }}
              height="244px"
            />

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ p: "6px" }}
            >
              <Typography color="#667185" fontSize={16}>
                Total Flight Cost
              </Typography>
              <Typography fontSize="20px" fontWeight={600}>
                NGN {amount}
              </Typography>
            </Box>
            {/* <Divider sx={{ mt: "4px" }} />
            <Box
              height="49px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Button
                variant="text"
                sx={{
                  color: "#379E66",
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                View Breakdown
              </Button>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const Passengers = () => {
  return (
    <Box>
      <DashboardTopTitle
        title="Passengers"
        onClickFirst={() => {}}
        firstBtnIcon={<CloudUploadOutlined />}
        firstBtnTitle="Export list"
        firstBtn
        secondBtn
        secondBtnIcon={<Add />}
        secondBtnTitle="Invite"
      />
      <OrderTable />
    </Box>
  );
};
